// This file is part of InvenioRDM
// Copyright (C) 2023 CERN.
//
// Invenio App RDM is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

/**
 * Add here all the overridden components of your app.
 */

import DepositFormCustomFields from "../../components/invenio_app_rdm/DepositFormCustomFields";
import DepositStatusBoxes from "../../components/invenio_app_rdm/DepositStatusBoxes";

export const overriddenComponents = {
  "InvenioAppRdm.Deposit.CustomFields.container": DepositFormCustomFields,
  "InvenioRdmRecords.CommunityHeader.RemoveCommunityButton.Container": () =>
    null,
  "InvenioAppRdm.Deposit.CardDepositStatusBox.container": DepositStatusBoxes,
};
